import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const updateReqArriveLateSlice = createSlice({
  name: "updateReqArriveLate",
  initialState,
  reducers: {
    updateReqArriveLateStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    updateReqArriveLateSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    updateReqArriveLateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  updateReqArriveLateStart,
  updateReqArriveLateSuccess,
  updateReqArriveLateFailed,
} = updateReqArriveLateSlice.actions;

export default updateReqArriveLateSlice.reducer;
